var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spectrum-Tabs",class:[
  ("spectrum-Tabs--" + _vm.directionClass),
    {
      'spectrum-Tabs--quiet': _vm.quiet,
      'spectrum-Tabs--compact': _vm.compact,
    }
  ]},[_vm._l((_vm.vForable(_vm.items)),function(ref,index){
  var item = ref.item;
  var key = ref.key;
return _c('div',{key:key,ref:("tabItem-" + index),refInFor:true,staticClass:"spectrum-Tabs-item",class:{
      'is-selected': _vm.innerSelectedIndex === index,
    },attrs:{"tabindex":key},on:{"click":function($event){return _vm.onItemSelect($event, index)}}},[(!_vm.noIcon && item.iconName)?_c('Icon',{attrs:{"name":item.iconName,"size":_vm.size}}):_vm._e(),(!_vm.noText && item.label)?_c('label',{staticClass:"spectrum-Tabs-itemLabel",domProps:{"textContent":_vm._s(item.label)}}):_vm._e()],1)}),(_vm.indicatorStyle)?_c('div',{staticClass:"spectrum-Tabs-selectionIndicator",style:(_vm.indicatorStyle)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }